import api from './request'

export function get (data) {
  return api({
    url: '/states',
    method: 'get',
    params: data
  })
}
